export const defaultOptions = [
  "None Not at all",
  "Slight Rare, less than a day or two",
  "Mild Several days",
  "Moderate More than half the days",
  "Severe Nearly every day"
];

export const individualQuestions_Level1 = [
  {
    id: 0,
    question: "Which country are you in?",
    options: [
      "India",
      "Indonesia",
      "Australia",
      "Afganistan",
      "Algeria",
      "Bermuda",
      "Zimbabwe",
    ],
    category: "demographic",
    scores: [0, 0, 0, 0, 0, 0, 0],
    inputType: "select",
  },
  {
    id: 1,
    question: "What is your gender identity?",
    options: ["Man", "Women",],
    category: "demographic",
    scores: [0, 0, ],
    inputType: "radio",
  },
  {
    id: 2,
    question: "Have you ever been in therapy before?",
    options: ["No", "Yes"],
    category: "demographic",
    scores: [0, 0],
    inputType: "radio",
  },
  {
    id: 3,
    question: "Little interest or pleasure in doing things?",
    options: defaultOptions,
    inputType: "radio",
    category: "depression",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 4,
    question: "Feeling down, depressed, or hopeless?",
    options:defaultOptions,
    inputType: "radio",
    category: "depression",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 5,
    question: "Feeling more irritated, grouchy, or angry than usual?",
    options: defaultOptions,
    inputType: "radio",
    category: "anger",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 6,
    question: "Sleeping less than usual, but still have a lot of energy?",
    options: defaultOptions,
    inputType: "radio",
    category: "mania",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 7,
    question:
      "Starting lots more projects than usual or doing more risky things than usual?",
    options: defaultOptions,
    inputType: "radio",
    category: "mania",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 8,
    question: "Feeling nervous, anxious, frightened, worried, or on edge?",
    options: defaultOptions,
    inputType: "radio",
    category: "anxiety",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 9,
    question: "Avoiding situations that make you anxious?",
    options: defaultOptions,
    inputType: "radio",
    category: "anxiety",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 10,
    question: "Problems with sleep that affected your sleep quality overall?",
    options: defaultOptions,
    inputType: "radio",
    category: "sleep",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 11,
    question: "Unexplained aches and pains (e.g., head, back, joints, abdomen, legs)?",
    options: defaultOptions,
    inputType: "radio",
    category: "SomaticSymptoms",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 12,
    question: "Feeling that your illnesses are not being taken seriously enough?",
    options: defaultOptions,
    inputType: "radio",
    category: "SomaticSymptoms",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 13,
    question: "Unpleasant thoughts, urges, or images that repeatedly enter your mind?",
    options: defaultOptions,
    inputType: "radio",
    category: "ThoughtsAndBehaviors",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 14,
    question: "Feeling driven to perform certain behaviors or mental acts over and over again?",
    options: defaultOptions,
    inputType: "radio",
    category: "ThoughtsAndBehaviors",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 15,
    question: "Drinking at least 4 drinks of any kind of alcohol in a single day?",
    options: defaultOptions,
    inputType: "radio",
    category: "SubstanceUse",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 16,
    question: "Smoking any cigarettes, a cigar, or pipe, or using snuff or chewing tobacco?",
    options: defaultOptions,
    inputType: "radio",
    category: "SubstanceUse",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 17,
    question: "Using any of the following medicines ON YOUR OWN, that is, without a doctor’s prescription, in greater amounts or longer than prescribed [e.g., painkillers (like Vicodin), stimulants (like Ritalin or Adderall), sedatives or tranquilizers (like sleeping pills or Valium), or drugs like marijuana, cocaine or crack, club drugs (like ecstasy), hallucinogens (like LSD), heroin, inhalants or solvents (like glue), or methamphetamine (like speed)]?",
    options: defaultOptions,
    inputType: "radio",
    category: "SubstanceUse",
    scores: [0, 1, 2, 3, 4],
  },
];

export const individualQuestions_Level2 = {
  depression: [
    {
      id: 0,
      question: "I felt worthless",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always",
      ],
      inputType: "radio",
      category: "depression",
      scores: [1, 2, 3, 4, 5], // Added consistent scoring system
    },
    {
      id: 1,
      question: "I felt that I had nothing to look forward to.",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always",
      ],
      inputType: "radio",
      category: "depression",
      scores: [1, 2, 3, 4, 5], // Added consistent scoring system
    },
    {
      id: 2,
      question: "I felt helpless.",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always",
      ],
      inputType: "radio",
      category: "depression",
      scores: [1, 2, 3, 4, 5], // Added consistent scoring system
    },
    {
      id: 3,
      question: "I felt sad",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always",
      ],
      inputType: "radio",
      category: "depression",
      scores: [1, 2, 3, 4, 5], // Added consistent scoring system
    },
    {
      id: 4,
      question: "I felt like a failure.",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always",
      ],
      inputType: "radio",
      category: "depression",
      scores: [1, 2, 3, 4, 5], // Added consistent scoring system
    },
    {
      id: 5,
      question: "I felt depressed",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always",
      ],
      inputType: "radio",
      category: "depression",
      scores: [1, 2, 3, 4, 5], // Added consistent scoring system
    },
    {
      id: 6,
      question: "I felt unhappy",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always",
      ],
      inputType: "radio",
      category: "depression",
      scores: [1, 2, 3, 4, 5], // Added consistent scoring system
    },
    {
      id: 7,
      question: "I felt hopeless",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always",
      ],
      inputType: "radio",
      category: "depression",
      scores: [1, 2, 3, 4, 5], // Added consistent scoring system
    },
    
  ],
  anxiety: [
    {
      id: 0,
      question: "I felt fearful.",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always",
      ],
      inputType: "radio",
      category: "anxiety",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: 1,
      question: "I felt anxious.",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always",
      ],
      inputType: "radio",
      category: "anxiety",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: 2,
      question: "I felt worried. ",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always",
      ],
      inputType: "radio",
      category: "anxiety",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: 3,
      question: "I found it hard to focus on anything other than my anxiety. ",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always",
      ],
      inputType: "radio",
      category: "anxiety",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: 4,
      question: "I felt nervous",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always",
      ],
      inputType: "radio",
      category: "anxiety",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: 5,
      question: "I felt uneasy.",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always", 
      ],
      inputType: "radio",
      category: "anxiety",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: 6,
      question: "I felt tense.",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always",
      ],
      inputType: "radio",
      category: "anxiety",
      scores: [0, 1, 2, 3, 4],
    },
  ],
  mania: [
    {
      id: 0,
      question: "I felt tense.",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always",
      ],
      inputType: "radio",
      category: "mania",
      scores: [0, 1, 2, 3, 4],
    },
  ],
  anger: [
    {
      id: 0,
      question: "I was irritated more than people knew.",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always"
      ],
      inputType: "radio",
      category: "anger",
      scores: [1, 2, 3, 4, 5],
    },
    {
      id: 1,
      question: "I felt angry.",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always"
      ],
      inputType: "radio",
      category: "anger",
      scores: [1, 2, 3, 4, 5],
    },
    {
      id: 2,
      question: "I felt like I was ready to explode.",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always"
      ],
      inputType: "radio",
      category: "anger",
      scores: [1, 2, 3, 4, 5],
    },
    {
      id: 3,
      question: "I was grouchy",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always"
      ],
      inputType: "radio",
      category: "anger",
      scores: [1, 2, 3, 4, 5],
    },
    {
      id: 4,
      question: "I felt annoyed.",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always"
      ],
      inputType: "radio",
      category: "anger",
      scores: [1, 2, 3, 4, 5],
    },
  ],
  sleep: [
    {
      id: 0,
      question: "My sleep was restless.",
      options: [
        "Not at all",
        "A little bit",
        "Somewhat",
        "Quite a bit",
        "Very much"
      ],
      inputType: "radio",
      category: "sleep",
      scores: [1, 2, 3, 4, 5],
    },
    {
      id: 1,
      question: "I was satisfied with my sleep.",
      options: [
        "Not at all",
        "A little bit",
        "Somewhat",
        "Quite a bit",
        "Very much"
      ],
      inputType: "radio",
      category: "sleep",
      scores: [5, 4, 3, 2, 1],
    },
    {
      id: 2,
      question: "My sleep was refreshing.",
      options: [
        "Not at all",
        "A little bit",
        "Somewhat",
        "Quite a bit",
        "Very much"
      ],
      inputType: "radio",
      category: "sleep",
      scores: [5, 4, 3, 2, 1],
    },
    {
      id: 3,
      question: "I had difficulty falling asleep.",
      options: [
        "Not at all",
        "A little bit",
        "Somewhat",
        "Quite a bit",
        "Very much"
      ],
      inputType: "radio",
      category: "sleep",
      scores: [1, 2, 3, 4, 5],
    },
    {
      id: 4,
      question: "I had trouble staying asleep.",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always"
      ],
      inputType: "radio",
      category: "sleep",
      scores: [1, 2, 3, 4, 5],
    },
    {
      id: 5,
      question: "I had trouble sleeping.",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always"
      ],
      inputType: "radio",
      category: "sleep",
      scores: [1, 2, 3, 4, 5],
    },
    {
      id: 6,
      question: ". I got enough sleep",
      options: [
        "Never",
        "Rarely",
        "Sometimes",
        "Often",
        "Always"
      ],
      inputType: "radio",
      category: "sleep",
      scores: [5, 4, 3, 2, 1],
    },
    {
      id: 7,
      question: "My sleep quality was....",
      options: [
        "Very Poor",
        "Poor",
        "Fair",
        "Good",
        "Very good"
      ],
      inputType: "radio",
      category: "sleep",
      scores: [5, 4, 3, 2, 1],
    },
  ],
  SomaticSymptoms: [
     {
      id: 0,
      question: "Stomach pain ",
      options: [
        "Not bothered at all",
        "Botherred at little",
        "Bothered a lot",
      ],
      inputType: "radio",
      category: "SomaticSymptoms",
      scores: [0, 1, 2, ],
    },
     {
      id: 1,
      question: "Pain in your arms, legs, or joints (knees, hips, etc.) ",
      options: [
        "Not bothered at all",
        "Botherred at little",
        "Bothered a lot",
      ],
      inputType: "radio",
      category: "SomaticSymptoms",
      scores: [0, 1, 2, ],
    },
     {
      id: 2,
      question: "Back pain ",
      options: [
        "Not bothered at all",
        "Botherred at little",
        "Bothered a lot",
      ],
      inputType: "radio",
      category: "SomaticSymptoms",
      scores: [0, 1, 2, ],
    },
     {
      id: 3,
      question: "Constipation, loose bowels, or diarrhea",
      options: [
        "Not bothered at all",
        "Botherred at little",
        "Bothered a lot",
      ],
      inputType: "radio",
      category: "SomaticSymptoms",
      scores: [0, 1, 2, ],
    },
     {
      id: 4,
      question: "Menstrual cramps or other problems with your periods WOMEN ONLY ",
      options: [
        "Not bothered at all",
        "Botherred at little",
        "Bothered a lot",
      ],
      inputType: "radio",
      category: "SomaticSymptoms",
      scores: [0, 1, 2, ],
    },
  ],
  ThoughtsAndBehaviors: [
    {
      id: 0,
      question: "On average, how much time is occupied by these thoughts or behaviors each day?",
      options: [
        "None",
        "Mild(Less than an hour a day)",
        "Moderate(1-3 hours a day)",
        "Severe(3-8 hours a day)",
        "Extreme(More than 8 hours a day)",
      ],
      inputType: "radio",
      category: "ThoughtsAndBehaviors",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: 1,
      question: "How much distress do these thoughts or behaviors cause you?",
      options: [
        "None",
        "Mild((slightly disturbing)",
        "Moderate(disturbing but still manageable)",
        "Severe(very disturbing)",
        "Extreme(overwhelming distress)",
      ],
      inputType: "radio",
      category: "ThoughtsAndBehaviors",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: 2,
      question: "How hard is it for you to control these thoughts or behaviors?",
      options: [
        "Complete control",
        "Much control (usually able to control thoughts or behaviors)",
        "Moderate control(sometimes able to control thoughts or behaviors)",
        "Little control(infrequently able to control thoughts or behaviors)",
        "No control (unable to control thoughts or behaviors)",
      ],
      inputType: "radio",
      category: "ThoughtsAndBehaviors",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: 3,
      question: "How much do these thoughts or behaviors cause you to avoid doing anything, going anyplace, or being with anyone?",
      options: [
        "No avoidance",
        "Mild (occasional avoidance)",
        "Moderate (regularly avoid doing these things)",
        "Severe (frequent and extensiveavoidance)",
        "Extreme(nearly complete avoidance; house-bound)",
      ],
      inputType: "radio",
      category: "ThoughtsAndBehaviors",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: 4,
      question: "How much do these thoughts or behaviors interfere with school, work, or your social or family life?",
      options: [
        "None",
        "Mild(Slight interference)",
        "Moderate(definite interference with functioning, but still manageable)",
        "Severe(substantial interference)",
        "Extreme(near-total interference; incapacitated))",
      ],
      inputType: "radio",
      category: "ThoughtsAndBehaviors",
      scores: [0, 1, 2, 3, 4],
    },
  ],
  SubstanceUse: [
     {
    id: 0,
    question: "During the past TWO (2) WEEKS, how often did you use painkillers (like Vicodin) ON YOUR OWN, that is, without a doctor’s prescription, in greater amounts or longer than prescribed?",
    options: [
      "Not at all",
      "One or two days",
      "Several days",
      "More than half the days",
      "Nearly every day",
    ],
    inputType: "radio",
    category: "SubstanceUse",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 1,
    question: "During the past TWO (2) WEEKS, how often did you use stimulants (like Ritalin, Adderall) ON YOUR OWN, that is, without a doctor’s prescription, in greater amounts or longer than prescribed?",
    options: [
      "Not at all",
      "One or two days",
      "Several days",
      "More than half the days",
      "Nearly every day",
    ],
    inputType: "radio",
    category: "SubstanceUse",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 2,
    question: "During the past TWO (2) WEEKS, how often did you use sedatives or tranquilizers (like sleeping pills or Valium) ON YOUR OWN, that is, without a doctor’s prescription, in greater amounts or longer than prescribed?",
    options: [
      "Not at all",
      "One or two days",
      "Several days",
      "More than half the days",
      "Nearly every day",
    ],
    inputType: "radio",
    category: "SubstanceUse",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 3,
    question: "During the past TWO (2) WEEKS, how often did you use marijuana ON YOUR OWN, that is, without a doctor’s prescription, in greater amounts or longer than prescribed?",
    options: [
      "Not at all",
      "One or two days",
      "Several days",
      "More than half the days",
      "Nearly every day",
    ],
    inputType: "radio",
    category: "SubstanceUse",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 4,
    question: "During the past TWO (2) WEEKS, how often did you use cocaine or crack ON YOUR OWN, that is, without a doctor’s prescription, in greater amounts or longer than prescribed?",
    options: [
      "Not at all",
      "One or two days",
      "Several days",
      "More than half the days",
      "Nearly every day",
    ],
    inputType: "radio",
    category: "SubstanceUse",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 5,
    question: "During the past TWO (2) WEEKS, how often did you use club drugs (like ecstasy) ON YOUR OWN, that is, without a doctor’s prescription, in greater amounts or longer than prescribed?",
    options: [
      "Not at all",
      "One or two days",
      "Several days",
      "More than half the days",
      "Nearly every day",
    ],
    inputType: "radio",
    category: "SubstanceUse",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 6,
    question: "During the past TWO (2) WEEKS, how often did you use hallucinogens (like LSD) ON YOUR OWN, that is, without a doctor’s prescription, in greater amounts or longer than prescribed?",
    options: [
      "Not at all",
      "One or two days",
      "Several days",
      "More than half the days",
      "Nearly every day",
    ],
    inputType: "radio",
    category: "SubstanceUse",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 7,
    question: "During the past TWO (2) WEEKS, how often did you use heroin ON YOUR OWN, that is, without a doctor’s prescription, in greater amounts or longer than prescribed?",
    options: [
      "Not at all",
      "One or two days",
      "Several days",
      "More than half the days",
      "Nearly every day",
    ],
    inputType: "radio",
    category: "SubstanceUse",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 8,
    question: "During the past TWO (2) WEEKS, how often did you use inhalants or solvents (like glue) ON YOUR OWN, that is, without a doctor’s prescription, in greater amounts or longer than prescribed?",
    options: [
      "Not at all",
      "One or two days",
      "Several days",
      "More than half the days",
      "Nearly every day",
    ],
    inputType: "radio",
    category: "SubstanceUse",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: 9,
    question: "During the past TWO (2) WEEKS, how often did you use methamphetamine (like speed) ON YOUR OWN, that is, without a doctor’s prescription, in greater amounts or longer than prescribed?",
    options: [
      "Not at all",
      "One or two days",
      "Several days",
      "More than half the days",
      "Nearly every day",
    ],
    inputType: "radio",
    category: "SubstanceUse",
    scores: [0, 1, 2, 3, 4],
  },
  ],
};

export const teenQuestions_Level1 = [
  {
    id: 0,
    question: "Which country are you in?",
    options: [
      "India",
      "Indonesia",
      "Australia",
      "Afganistan",
      "Algeria",
      "Bermuda",
      "Zimbabwe",
    ],
    inputType: "select",
    category: "demographic",
    scores: [0, 0, 0, 0, 0, 0, 0],
  },
  {
    id: 1,
    question: "How often do you feel overwhelmed with school work?",
    options: defaultOptions,
    inputType: "radio",
    category: "academic_stress",
    scores: [0, 1, 2, 3, 4],
  },
  // Add more teen-specific level 1 questions...
];

export const categoryThresholds = {
  depression: 2, // Example: If depression score > 6, show depression level 2
  anxiety: 2,
  mania: 2,
  anger: 2,
  sleep: 2,
  SomaticSymptoms: 2,
  ThoughtsAndBehaviors: 2,
  SubstanceUse: 2,
};
